import type { State } from '../../types';
import type { NetworkViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function networksNotDeleted(state: State): NetworkViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.networksById).filter((e) => !e.deleted);
}
